import type { InterestBasis } from '@/api/personalLoans'
import { Input } from '@/components/ui/input'
import { Select } from '@/components/ui/select'
import { LABEL_CLS } from './shared'

export function InterestFields({
  basis,
  rateText,
  onBasisChange,
  onRateChange,
  rateError,
}: {
  basis: InterestBasis
  rateText: string
  onBasisChange: (b: InterestBasis) => void
  onRateChange: (t: string) => void
  rateError: string | null
}) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <label className={LABEL_CLS}>Interest</label>
        <Select
          aria-label="Interest"
          value={basis}
          onChange={(v) => onBasisChange(v as InterestBasis)}
        >
          <option value="NONE">No interest</option>
          <option value="MONTHLY">% per month</option>
          <option value="YEARLY">% per year</option>
        </Select>
      </div>
      {basis !== 'NONE' && (
        <div>
          <label htmlFor="loan-rate" className={LABEL_CLS}>
            Rate (%)
          </label>
          <Input
            id="loan-rate"
            inputMode="decimal"
            value={rateText}
            onChange={(e) => onRateChange(e.target.value)}
          />
          {rateError && <p className="mt-1 text-xs text-[var(--fl-error)]">{rateError}</p>}
        </div>
      )}
    </div>
  )
}
